import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { LeadReferalFilterSelectedValues } from '../../../configs/lead-referal-filter-config/filter-selected-values';
import { leadReferalFilterConfig } from '../../../configs/lead-referal-filter-config';

export const LeadReferalFilter = () => {
  return (
    <InputFilterTrigger
      renderValues={LeadReferalFilterSelectedValues}
      filterLabel='Referal'
      config={leadReferalFilterConfig}
    />
  );
};
